// Slides issus du « Guide de la conduite accompagnée » (guide officiel remis à l'élève
// et à l'accompagnateur lors du rendez-vous préalable). Intégrés dans les décks
// RDV préalable, RVP 1 et RVP 2 — chapitre dédié en fin de séance.

export const GUIDE_AAC_PREALABLE_SLIDES = [
  {
    type: 'section',
    number: '📘',
    title: 'Le guide de la conduite accompagnée',
    note: "Remis officiellement aujourd'hui à l'élève et à l'accompagnateur — les points essentiels ensemble · 15 min",
  },
  {
    type: 'content',
    kicker: 'Guide AAC · Les 3 formules',
    title: 'Trois façons de conduire accompagné',
    bullets: [
      "AAC — dès 15 ans : ≥ 1 an et ≥ 3 000 km accompagné, examen dès 17 ans, permis probatoire raccourci à 2 ans",
      "Conduite supervisée (CS) — dès 18 ans : avant l'examen ou après un échec, pour gagner de l'expérience à moindre coût",
      "Conduite encadrée (CE) — dès 16 ans : réservée aux élèves des filières professionnelles de la conduite",
      "Dans les 3 cas : formation initiale complète en école de conduite d'abord (code + ≥ 20 h de conduite)",
    ],
    footnote: 'Guide de la conduite accompagnée · pages 2-3',
    notes: "Présente les 3 formules. Insiste : l'AAC est statistiquement la meilleure préparation — plus d'expérience avant l'autonomie.",
  },
  {
    type: 'stat',
    number: '6 → 12',
    label: 'points — le permis probatoire AAC remonte à 12 points en 2 ans seulement (+3 pts/an) contre 3 ans en filière classique (+2 pts/an)',
    source: 'Guide de la conduite accompagnée',
    context: "À condition de ne perdre aucun point pendant la période probatoire. Un avantage concret de l'AAC, en plus d'un taux de réussite supérieur à l'examen.",
  },
  {
    type: 'content',
    kicker: 'Guide AAC · L\'accompagnateur',
    title: "Être accompagnateur : les 2 casquettes",
    bullets: [
      "Réglementaire : permis B depuis ≥ 5 ans sans interruption, accord de l'assureur, mention au contrat de formation, présence obligatoire aux rendez-vous pédagogiques",
      "Comportemental : patience et calme — vous êtes le co-pilote, pas le juge",
      "Montrer l'exemple en toutes circonstances : votre conduite devient la référence de l'élève",
      "Un ou plusieurs accompagnateurs possibles (parents, proches) — chacun déclaré",
    ],
    footnote: 'Guide de la conduite accompagnée · pages 6-8',
    notes: "Moment clé du RDV préalable : responsabiliser l'accompagnateur sans le stresser. Rappelle qu'il n'a pas de pédales — tout se joue dans l'anticipation verbale.",
  },
  {
    type: 'content',
    kicker: 'Guide AAC · Un véhicule partagé',
    title: 'Avant le premier trajet : apprivoiser la voiture',
    bullets: [
      "Se familiariser : réglages siège / rétroviseurs / volant, emplacement des commandes (essuie-glaces, feux, dégivrage)",
      "S'habituer aux réactions : point de patinage de l'embrayage, mordant du freinage, gabarit",
      "Se soucier de l'état : pression des pneus, niveaux, éclairage — l'élève participe à l'entretien",
      "Équipement conseillé : rétroviseur intérieur additionnel pour l'accompagnateur + disque « conduite accompagnée » à l'arrière",
    ],
    footnote: 'Guide de la conduite accompagnée · page 9',
  },
  {
    type: 'content',
    kicker: 'Guide AAC · Bien démarrer',
    title: 'Les premiers kilomètres : courts, variés, notés',
    bullets: [
      "Commencer par des trajets courts (15 à 30 min) sur itinéraires connus et calmes, puis allonger progressivement",
      "10 minutes en ville dense fatiguent autant que 30 minutes sur route de campagne — doser l'exigence",
      "Varier très vite les itinéraires : pluie, nuit, campagne, ville — « c'est l'occasion qui fait le larron »",
      "Tout consigner dans le livret d'apprentissage : kilomètres, conditions, ressenti",
    ],
    footnote: 'Guide de la conduite accompagnée · pages 12-13',
  },
  {
    type: 'stat',
    number: '500 km',
    label: "le cap où le conducteur novice commence à s'affirmer… et où l'excès de confiance devient le premier piège",
    source: 'Guide de la conduite accompagnée · page 13',
    context: "En face : un conducteur expérimenté totalise souvent 300 000 km. À 500 km, on ne sait pas encore conduire — on commence à apprendre.",
  },
  {
    type: 'content',
    kicker: "Guide AAC · Document indispensable",
    title: "L'attestation d'assurance : à faire remplir AVANT de rouler",
    bullets: [
      "Demande d'extension de garantie : remplie par le souscripteur — élève, véhicule(s), contrat, accompagnateur(s) + cachet de l'auto-école",
      "Lettre d'accord de l'assureur : signée et tamponnée par la compagnie (responsabilité civile + dommages)",
      "Extension gratuite : aucun surcoût ni modification de franchise possible (mention légale)",
      "Prend effet à la date de l'AFFI — le formulaire est téléchargeable dans la Base documentaire du site",
    ],
    footnote: 'Formulaire officiel · téléchargeable sur codevoiture.fr → Ressources',
    notes: "Remets le formulaire imprimé aux familles aujourd'hui, ou indique-leur le téléchargement sur le site. Vérifie au RVP1 qu'il est signé par l'assureur.",
  },
  {
    type: 'quote',
    text: "On retient 20 % de ce que l'on entend, mais 70 % de ce que l'on fait soi-même. La conduite accompagnée, c'est apprendre en roulant.",
    author: 'Guide de la conduite accompagnée',
  },
];

export const GUIDE_AAC_RVP1_SLIDES = [
  {
    type: 'section',
    number: '📘',
    title: 'Retour sur le guide AAC',
    note: 'Les fondamentaux du guide remis au RDV préalable — à réactiver après vos premiers 1 000 km · 15 min',
  },
  {
    type: 'stat',
    number: '15 %',
    label: 'des conducteurs tués sur la route ont entre 18 et 24 ans… alors que cette tranche d\'âge ne représente que 8 % de la population',
    source: 'Guide de la conduite accompagnée · page 4',
    context: "C'est exactement pour réduire ce sur-risque des novices que la conduite accompagnée existe : accumuler de l'expérience AVANT l'autonomie.",
  },
  {
    type: 'content',
    kicker: 'Guide AAC · La pression des pairs',
    title: 'Savoir dire non fait partie de la conduite',
    bullets: [
      "Le groupe pousse aux risques : vitesse « pour voir », musique à fond, téléphone, alcool en soirée",
      "Au volant, le conducteur est seul responsable — pénalement et civilement",
      "Préparer ses réponses à l'avance : « c'est moi qui conduis, c'est moi qui décide »",
      "Accompagnateurs : évoquez ces situations à froid, avant qu'elles n'arrivent",
    ],
    footnote: 'Guide de la conduite accompagnée · page 4',
  },
  {
    type: 'content',
    kicker: 'Guide AAC · Système routier',
    title: 'VORACE — lire la route comme un système',
    bullets: [
      "Véhicule : état, réglages, chargement",
      "Organisation : itinéraire, horaires, marge de temps",
      "Réglementation : signalisation, règles de priorité",
      "Accompagnateur : guide, prévient, rassure",
      "Conducteur : forme, fatigue, émotions du moment",
      "Environnement : météo, trafic, autres usagers",
    ],
    footnote: 'Guide de la conduite accompagnée · pages 16-17',
    notes: "Fais énumérer le sigle par la salle. Chaque trajet accompagné devrait commencer par un mini-scan VORACE de 30 secondes.",
  },
  {
    type: 'content',
    kicker: 'Guide AAC · Méthode phare',
    title: 'La conduite commentée',
    bullets: [
      "Le conducteur dit à voix haute ce qu'il voit, ce qu'il prévoit, ce qu'il fait",
      "L'accompagnateur peut commenter d'abord, en conduisant, pour montrer l'exemple",
      "On retient 70 % de ce que l'on fait : verbaliser ancre l'anticipation",
      "10 minutes par trajet suffisent — puis on débriefe à l'arrêt, jamais en roulant",
    ],
    footnote: 'Guide de la conduite accompagnée · page 18',
  },
  {
    type: 'content',
    kicker: 'Guide AAC · Vigilance',
    title: "Vigilance × exigence : l'équation de l'accident",
    bullets: [
      "Quand l'exigence de la circulation monte (ville dense, pluie, nuit), la vigilance doit monter aussi",
      "Le conflit naît quand l'exigence dépasse la vigilance disponible",
      "L'accident guette après le conflit non résolu — c'est une chaîne, pas une fatalité",
      "Fatigué, stressé, pressé ? On reporte le trajet — décision de conducteur responsable",
    ],
    footnote: 'Guide de la conduite accompagnée · page 19',
  },
  {
    type: 'qcm',
    question: 'Après le cap des 500 premiers kilomètres, quel est le principal piège qui guette le conducteur novice ?',
    options: [
      { text: "L'excès de confiance", correct: true },
      { text: 'Le manque de technique' },
      { text: 'La peur de conduire' },
    ],
    explanation: "Vers 500 km, le novice commence à s'affirmer et relâche son attention. Le guide rappelle qu'un conducteur expérimenté totalise 300 000 km : à 500 km, l'apprentissage ne fait que commencer.",
    engagement: 'Je continue à conduire comme si chaque trajet était le premier : concentré, sans distraction.',
  },
];

export const GUIDE_AAC_RVP2_SLIDES = [
  {
    type: 'section',
    number: '📘',
    title: "Guide AAC · Anticiper comme un expert",
    note: 'Dernière ligne droite avant l\'examen : les réflexes experts du guide · 15 min',
  },
  {
    type: 'content',
    kicker: 'Guide AAC · Anticipation',
    title: 'Voir au-delà du visible',
    bullets: [
      "Dangers potentiels : prévoir ce qui est caché — piéton derrière le camion, portière qui s'ouvre, ballon qui roule",
      "Zones d'incertitude : tant qu'on ne sait pas, on ralentit et on se tient prêt",
      "Se mettre à la place des autres usagers pour prévoir leurs déplacements",
      "Regard loin devant + rétroviseurs toutes les 5 à 10 secondes",
    ],
    footnote: 'Guide de la conduite accompagnée · pages 20-23',
  },
  {
    type: 'stat',
    number: '1 seconde',
    label: 'de temps de réaction moyen avant même de commencer à freiner — bien davantage avec alcool, cannabis, fatigue ou téléphone',
    source: 'Guide de la conduite accompagnée · page 28',
    context: 'À 50 km/h, 1 seconde = 14 mètres parcourus sans aucune action. La distance d\'arrêt = temps de réaction + freinage.',
  },
  {
    type: 'content',
    kicker: 'Guide AAC · Gagner du temps',
    title: 'Le pied au-dessus du frein',
    bullets: [
      "En zone de danger identifiée (école, piétons, intersection masquée) : pied prêt au-dessus du frein",
      "Temps de réaction divisé par 2 : environ une demi-seconde gagnée",
      "≈ 7 mètres gagnés à 50 km/h — souvent la différence entre l'évitement et le choc",
      "Réflexe d'expert à montrer à l'examinateur : anticipation visible = points gagnés",
    ],
    footnote: 'Guide de la conduite accompagnée · page 29',
  },
  {
    type: 'content',
    kicker: 'Guide AAC · Facteurs de risque',
    title: "Les facteurs d'accidents s'additionnent",
    bullets: [
      "Fatigue + retard + téléphone + pluie : chaque facteur multiplie le risque des autres",
      "Alcool + cannabis : risque d'accident mortel multiplié par 15",
      "Environ 2 % des conducteurs impliqués dans un accident corporel en période probatoire ont une alcoolémie positive",
      "Savoir renoncer ou reporter un trajet est une compétence de conducteur — pas une faiblesse",
    ],
    footnote: 'Guide de la conduite accompagnée · pages 24-25',
  },
  {
    type: 'content',
    kicker: 'Guide AAC · Rappels examen',
    title: "Les rappels techniques avant l'épreuve",
    bullets: [
      "Giratoire : céder le passage à gauche, clignotant de sortie systématique",
      "Voies d'entrecroisement : ajuster l'allure, faciliter l'insertion des autres",
      "Distance d'arrêt = réaction + freinage — la règle des 6 pour l'estimer vite",
      "Contrôles visuels amples et visibles : l'examinateur doit les voir",
    ],
    footnote: 'Guide de la conduite accompagnée · pages 26-28',
  },
  {
    type: 'quote',
    text: "Au début, j'appuyais sur un frein imaginaire côté passager… Au fil des kilomètres, la confiance s'est installée des deux côtés. Aujourd'hui, je monte à côté d'un vrai conducteur.",
    author: "Témoignage d'un accompagnateur · Guide de la conduite accompagnée",
  },
];
